module.exports = require("chained-function");